import ExifReader from 'exifreader';

const MODES = {
  '1': 'grayscale',
  '4': 'CMYK',
  '2': 'Indexed',
  '3': 'RGB'
};

export default (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (eventReader) => {
      const tags = ExifReader.load(eventReader.target.result);
      const val = tags['Color Components'].value;
      resolve(MODES[val]);
    };
    reader.readAsArrayBuffer(file);
  });
}
